import { Loader2, SearchX, TriangleAlert } from "lucide-react";
import { CTAButton } from "@/components/common/Bits";

export function Spinner({ label = "Loading…" }) {
    return (
        <div className="flex flex-col items-center gap-3 text-brand-blue" data-testid="loading-spinner">
            <Loader2 className="h-8 w-8 animate-spin" />
            <span className="text-sm text-brand-ink/65">{label}</span>
        </div>
    );
}

export function EmptyState({ title = "Nothing here yet", desc, testid }) {
    return (
        <div className="flex flex-col items-center gap-3 rounded-3xl border border-dashed border-brand-blue/20 bg-white px-6 py-16 text-center" data-testid={testid || "empty-state"}>
            <SearchX className="h-10 w-10 text-brand-blue/30" />
            <h3 className="font-display text-xl font-semibold text-brand-blue">{title}</h3>
            {desc && <p className="max-w-sm text-sm text-brand-ink/65">{desc}</p>}
        </div>
    );
}

export function ErrorState({ onRetry, testid }) {
    return (
        <div className="flex flex-col items-center gap-4 rounded-3xl border border-brand-red/20 bg-white px-6 py-16 text-center" data-testid={testid || "error-state"}>
            <TriangleAlert className="h-10 w-10 text-brand-red" />
            <h3 className="font-display text-xl font-semibold text-brand-blue">Something went wrong</h3>
            {onRetry && <CTAButton onClick={onRetry}>Try Again</CTAButton>}
        </div>
    );
}

// Skeleton card for grids while data loads.
export function SkeletonCard() {
    return (
        <div className="overflow-hidden rounded-3xl bg-white shadow-brand" data-testid="skeleton-card">
            <div className="aspect-[4/3] animate-pulse bg-brand-blue/5" />
            <div className="space-y-3 p-5">
                <div className="h-4 w-2/3 animate-pulse rounded bg-brand-blue/10" />
                <div className="h-3 w-1/2 animate-pulse rounded bg-brand-blue/5" />
            </div>
        </div>
    );
}
